<ds-button
  [buttonInput]="buttonConfig"
  (click)="onClick()"
></ds-button>

@if(showAdvancePassbookPanel){<advance-passbook-panel [currencyCode]="currencyCode" (closePanelEvent)="closeAdvancePassbookPanel($event)">
</advance-passbook-panel>}